export default __webpack_public_path__ + "static/media/spaced_repetition.0e080a67.png";